
export const TIPO_PERSONA = {
    FISICA: 500,
    JURIDICA: 501
}

export const TIPO_DOCUMENTO = {
    DNI: 510,
    LE: 512,
    LC: 513,
    CUIT: 515
}

export const TIPO_GEOREFERENCIA = {
    OPEN_STREET_MAP: 530
}

export const GENERO = {
    MASCULINO: 560,
    FEMENINO: 561,
    INDEFINIDO: 562
}

export const ARCA_SEXO_A_GENERO = {
    'M': GENERO.MASCULINO,
    'F': GENERO.FEMENINO,
}
